module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('v-subheader', {
    staticClass: "overline pa-0"
  }, [_vm._v("Locations")]), _vm._v(" "), _vm._l((_vm.locations), function(location) {
    return _c('v-checkbox', _vm._b({
      key: location.id,
      staticClass: "mt-0",
      attrs: {
        "dense": "",
        "hide-details": "",
        "row": "",
        "value": location.id,
        "label": location.name
      },
      model: {
        value: (_vm.selected),
        callback: function($$v) {
          _vm.selected = $$v
        },
        expression: "selected"
      }
    }, 'v-checkbox', _vm.attrs, false))
  }), _vm._v(" "), (_vm.hint) ? _c('div', {
    staticClass: "caption grey--text",
    domProps: {
      "textContent": _vm._s(_vm.hint)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.warningMessage) ? _c('div', {
    staticClass: "caption warning--text",
    domProps: {
      "textContent": _vm._s(_vm.warningMessage)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.errorMessages && _vm.errorMessages.length > 0) ? _vm._l((_vm.errorMessages), function(error) {
    return _c('div', {
      staticClass: "caption error--text",
      domProps: {
        "textContent": _vm._s(error)
      }
    })
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ffc1d768","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pickers/LocationPicker.vue
// module id = 1552
// module chunks = 9